<template>
  <div>
    <WdsStack v-if="user.hasPermission('manage-projects')" gap-sm>
      <WdsButtonGhost v-if="inline" @click="edit = true">{{ $t('Edit') }}</WdsButtonGhost>
      <WdsButton v-else @click="edit = true">{{ $t('Edit Project') }}</WdsButton>
      <WdsMenu placement="bottom-start" :fallback-placements="['bottom']" :z-index="11" global>
        <template #trigger>
          <WdsButtonIcon transparent-background>
            <WdsIcon size="24" name="overflow-menu-horizontal" />
          </WdsButtonIcon>
        </template>
        <WdsMenuOption v-if="projectedEnded" @click="editStatus('open')">
          <WdsIcon :size="16" name="checkmark-outline" />
          {{ $t('Re-open Project') }}
        </WdsMenuOption>
        <WdsMenuOption v-else @click="editStatus('end')">
          <WdsIcon :size="16" name="close-outline" />
          {{ $t('End Project') }}
        </WdsMenuOption>
        <WdsMenuOption theme="DESTRUCTIVE" @click="editStatus('delete')">
          <WdsIcon :size="16" name="trash-can" />
          {{ $t('Delete Project') }}
        </WdsMenuOption>
      </WdsMenu>
    </WdsStack>
  </div>
  <ModalEditProject v-if="edit" :project="project" @close="edit = false" />
  <ModalEditProjectStatus
    v-if="editStatusBool"
    :status="status"
    :project="project"
    @close="editStatusBool = false"
    @deleted="emit('deleted')"
    @submitted="emit('submitted', status)"
  />
</template>

<script setup>
import {
  WdsMenu,
  WdsStack,
  WdsMenuOption,
  WdsIcon,
  WdsButtonGhost,
  WdsButton,
  WdsButtonIcon,
} from '@worksome/wds-components'
import { computed, ref } from 'vue'
import ModalEditProjectStatus from '@/components/Projects/ModalEditProjectStatus.vue'
import ModalEditProject from '@/components/Projects/ModalEditProject.vue'

const props = defineProps({
  project: {
    required: true,
    type: Object,
  },
  inline: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['deleted', 'submitted'])

const edit = ref(false)

const editStatusBool = ref(false)
const status = ref('')

const projectedEnded = computed(() => props.project.endDate !== null)

function editStatus(s) {
  status.value = s
  editStatusBool.value = true
}

defineExpose({
  editStatus,
})
</script>
